export * from "./dialog-content.component";
export * from "./dialot-content-templates.directive";